import React, { useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, AlertTriangle } from "lucide-react";
import { useLang } from "../../i18n";
import { imsafeItems } from "../../data/safety";

export default function SelfCheck() {
  const { t, lang } = useLang();
  // answers: id -> true (yes = risk) / false (no)
  const [answers, setAnswers] = useState({});

  const set = (id, val) => setAnswers((a) => ({ ...a, [id]: val }));
  const answered = Object.keys(answers).length;
  const anyRisk = Object.values(answers).some((v) => v === true);
  const allAnswered = answered === imsafeItems.length;

  const borderFor = (val) => {
    if (val === true) return "border-sonne/50";
    if (val === false) return "border-ready/40";
    return "";
  };

  return (
    <div>
      <p className="text-sm text-wachs-dim leading-relaxed max-w-2xl">{t.safety.selfcheck.intro}</p>

      <div className="mt-6 space-y-3">
        {imsafeItems.map((item) => {
          const val = answers[item.id];
          return (
            <div key={item.id} data-testid={`imsafe-item-${item.id}`} className={`grid-panel rounded-lg p-4 flex items-center gap-4 ${borderFor(val)}`}>
              <span className="font-mono text-xl w-8 text-center text-sonne shrink-0">{item.letter}</span>
              <p className="flex-1 text-sm leading-snug">{lang === "de" ? item.de : item.en}</p>
              <div className="flex gap-2 shrink-0">
                <button
                  onClick={() => set(item.id, true)}
                  data-testid={`imsafe-${item.id}-yes`}
                  className={`font-mono text-xs px-3 py-1.5 rounded border transition-colors ${val === true ? "bg-sonne/20 border-sonne text-sonne" : "border-wachs-dim/30 text-wachs-dim hover:border-sonne/50"}`}
                >
                  {t.safety.selfcheck.yes}
                </button>
                <button
                  onClick={() => set(item.id, false)}
                  data-testid={`imsafe-${item.id}-no`}
                  className={`font-mono text-xs px-3 py-1.5 rounded border transition-colors ${val === false ? "bg-ready/15 border-ready text-ready" : "border-wachs-dim/30 text-wachs-dim hover:border-ready/50"}`}
                >
                  {t.safety.selfcheck.no}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {allAnswered && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          data-testid="imsafe-result"
          className={`mt-6 rounded-lg p-5 flex items-start gap-3 border ${anyRisk ? "border-sonne/50 bg-sonne/10" : "border-ready/50 bg-ready/10"}`}
        >
          {anyRisk ? <AlertTriangle className="text-sonne shrink-0" /> : <ShieldCheck className="text-ready shrink-0" />}
          <p className={`text-sm ${anyRisk ? "text-sonne" : "text-ready"}`}>
            {anyRisk ? t.safety.selfcheck.caution : t.safety.selfcheck.allClear}
          </p>
        </motion.div>
      )}
    </div>
  );
}
